<template>
<div class="form-input-container">
 <label :for="inputId" class="form-label" 
          >{{ labelText }}
        </label>
        <select v-model="inputField" class="form-select" :id="inputId" :required="required === 1" >
        <option v-for="(option,index) in options" :value="option.value" :key="index" >
          {{ option.text }}
        </option>
    </select>
    <div class="invalid-feedback">
      {{ intl[$store.state.lang][errorMessageKey] }}
    </div>
</div>
</template>

<script>
import intl from "./intl/intl";


export default {
  name: "selectInput",
  components: {
   
   
  },

  props: {
      
      inputId: {
        type: String,
        default: null
      },
      
      labelKey: {
        type: String,
        default: null
      },
      required: {
        type: Boolean,
        default: false
      },
      defaultOptions: {
        //[{value: 'xxxxx',text:'yyyyy'},....]
        type: Array,
        default: () => []
      },
      errorMessageKey: {
        type: String,
        default: "base_error"
      }
     
        
  },
  mounted() {
    this.defaultOptions.map((opt) => {
      if(opt.selected){
        this.inputField = opt.value
      }
    })
    
    
   
  },
  beforeUnmount() {
    
  },
  data: function () {
    return {
      intl: intl,
      inputField: null,
      options: this.defaultOptions || []
    };
  },
  methods: {
     
    requiredInputIsOk(){
      if(this.required && this.inputField === null){
        return false
      }
      return true
    }
         
               
    
  
    
  },
  watch: {
   

  },
  computed: {
        labelText: function () {
          if(this.required){
            return this.intl[this.$store.state.lang][this.labelKey] + '*:'
          }else{
            return this.intl[this.$store.state.lang][this.labelKey] + ':'
          }
       
    },
    },
  
};
</script>
